import { createUseStyles } from "react-jss";
import { breakpoints } from "../../constants/breakpoints";

const styles = createUseStyles({
  logo: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    margin: "32px 15px 24px",
    padding: "0 9px",
    // Default heights (applies to UC and everything else by default)
    "& img": {
      maxHeight: "32px",
    },
    "& svg": {
      height: "32px",
    },
    [`@media (max-width: ${breakpoints.md}px)`]: {
      margin: "0",
      padding: "12px 32px",
      "& svg": {
        height: "40px",
      },
    },
    [`@media (max-width: ${breakpoints.sm}px)`]: {
      padding: "12px 16px",
      "& svg": {
        height: "40px",
      },
    },
  },

  // Overrides for AA & AS
  AA: {
    "& svg": {
      height: "64px !important",
    },
    "& img": {
      maxHeight: "64px !important",
    },
  },
  AS: {
    [`@media (max-width: ${breakpoints.md}px)`]: {
      padding: "7px 16px",
    },
    "& svg": {
      height: "64px !important",
    },
    "& img": {
      maxHeight: "64px !important",
    },
  },
  AC: {
    [`@media (max-width: ${breakpoints.md}px)`]: {
      "& svg": {
        width: "340px !important",
      },
    },
    [`@media (max-width: ${breakpoints.sm}px)`]: {
      "& svg": {
        width: "280px !important",
      },
    },
  },
  CHOICE: {
    marginTop: "48px",
    "& svg": {
      height: "44px !important",
    },
    "& img": {
      maxHeight: "44px !important",
    },
    [`@media (max-width: ${breakpoints.md}px)`]: {
      marginTop: "12px",
      marginBottom: "12px",
      padding: "7px 16px",
      "& svg": {
        height: "32px !important",
      },
      "& img": {
        maxHeight: "32px !important",
      },
    },
  },
});

export default styles;
